import { Check, Shield } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'

export interface ProposalDecisionActions {
  busy: boolean
  apply: () => void
  discard: () => void
}

/** Below sm the two actions share one row (tighter padding, equal widths) so the
 * docked bar stays two lines tall at 360 px instead of stacking the buttons. */
const PHONE_ACTION = 'max-sm:flex-1 max-sm:px-3'

/** Docked outside the workbench's scrolling content, on mobile as well as
 * desktop. Applying updates the working schema; it does not accept a version. */
export function ProposalDecisionBar({
  actions,
  hasErrors,
}: {
  actions: ProposalDecisionActions
  hasErrors: boolean
}) {
  const { t } = useTranslation()
  return (
    <footer
      className="flex shrink-0 flex-wrap items-center justify-between gap-3 border-t bg-card px-4 py-3 sm:px-6"
      data-testid="proposal-decision-bar"
    >
      <p className="flex min-w-0 items-start gap-2 text-xs text-muted-foreground">
        <Shield className="size-3.5 shrink-0" aria-hidden />
        {t('schemaAgent.workbench.reviewUnchanged')}
      </p>
      <div className="flex flex-1 flex-wrap items-center justify-end gap-2 sm:flex-none">
        <Button
          variant="outline"
          disabled={actions.busy}
          onClick={actions.discard}
          className={PHONE_ACTION}
        >
          {t('schemaAgent.workbench.discardProposal')}
        </Button>
        <Button
          variant="solid"
          disabled={actions.busy || hasErrors}
          onClick={actions.apply}
          className={PHONE_ACTION}
        >
          <Check className="size-4" aria-hidden />
          {t('schemaAgent.workbench.apply')}
        </Button>
      </div>
    </footer>
  )
}
